export default "__VITE_ASSET__BM5eKF7t__"